import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/api/client";

/**
 * Whether the current user may use the assistant (pilot allowlist, enforced server-side). Drives
 * the panel's visibility. On error (e.g. transient failure) we fail closed — hide the panel.
 */
export function useAssistantAccess(): { allowed: boolean; loading: boolean } {
  const query = useQuery({
    queryKey: ["assistant-access"],
    queryFn: () => apiFetch<{ allowed: boolean }>("/assistant/access"),
    staleTime: 5 * 60_000,
  });
  return { allowed: query.data?.allowed === true, loading: query.isLoading };
}
